function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRotation = function SvgRotation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "10 8 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m19.8 20.5 4.4 4.4-4.4 4.4v-3.41c-5.016-.506-8.8-2.728-8.8-5.39 0-2.662 3.784-4.884 8.8-5.39v2.189c-3.795.374-6.6 1.661-6.6 3.201s2.805 2.827 6.6 3.201V20.5Zm11 0c0-1.54-2.805-2.827-6.6-3.201V15.11c5.016.506 8.8 2.728 8.8 5.39 0 2.376-3.476 4.73-7.7 5.5v-2.2c3.267-.473 5.5-1.903 5.5-3.3Zm-11-5.39S21.14 15 22 15c.86 0 2.2.11 2.2.11v2.189S22.86 17.2 22 17.2c-.86 0-2.2.099-2.2.099V15.11Z",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgRotation;